import { connect } from 'react-redux'

import {
  adminSearchAgencies,
  fetchAgencyProfile,
  updateAgencyMultipleOfficeSettingInfo,
} from 'app/bond_cover/agency/agency_actions'
import MultiOfficeFormContainer from 'app/bond_cover/agency/multi_office_form_container'

interface IAgency {
  error: string
  createError: string
  registerError: string
  agency: any
}
interface ISession {
  teams: any[]
  currentTeam: any
}

const mapStateToProps = ({
  agency,
  session,
}: {
  agency: IAgency
  session: ISession
}) => ({
  error: agency.error,
  createError: agency.createError,
  registerError: agency.registerError,
  agency: agency.agency,
  teams: session.teams,
  currentTeam: session.currentTeam,
})

const mapDispatchToProps = (dispatch: any) => ({
  fetchAgencyProfile: (agencyGUID: any, fetchSuccess: any) =>
    dispatch(fetchAgencyProfile(agencyGUID, fetchSuccess)),
  searchAgencies: (
    q: any,
    pageSize: any,
    searchSuccess: any,
    excludedAgencies: any,
  ) =>
    dispatch(adminSearchAgencies(q, pageSize, searchSuccess, excludedAgencies)),
  updateAgencyMultipleOfficeSettingInfo: (
    teamGUID: any,
    attributes: any,
    attributesRemoved: any,
  ) =>
    dispatch(
      updateAgencyMultipleOfficeSettingInfo(
        teamGUID,
        attributes,
        attributesRemoved,
      ),
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultiOfficeFormContainer)
